// 交通費ワリカン 純関数ライブラリ
// 副作用なし・React/Firestore に非依存

export function calcGas(gas) {
  if (gas.useManual) return parseFloat(gas.manual) || 0;
  const d = parseFloat(gas.dist) || 0;
  const e = parseFloat(gas.eff) || 0;
  const p = parseFloat(gas.price) || 0;
  if (!d || !e || !p) return 0;
  return Math.ceil((d / e) * p);
}

export function roundTo(n, unit) {
  if (unit <= 1) return Math.round(n);
  return Math.round(n / unit) * unit;
}

export function computeResult(state) {
  const { people, gas, expenses, driverRate = 90, rounding = 100 } = state;
  if (people.length < 2) return null;

  const gasAmt = calcGas(gas);
  const totalCost = gasAmt + expenses.reduce((s, e) => s + (parseFloat(e.amount) || 0), 0);
  if (totalCost <= 0) return { balances: [], transfers: [], gasAmt, totalCost };

  const driverMult = driverRate / 100;
  const paid = {};
  people.forEach(p => { paid[p.id] = 0; });
  if (gasAmt > 0 && gas.paidBy && paid[gas.paidBy] !== undefined) paid[gas.paidBy] += gasAmt;
  expenses.forEach(e => {
    const amt = parseFloat(e.amount) || 0;
    if (amt > 0 && e.paidBy && paid[e.paidBy] !== undefined) paid[e.paidBy] += amt;
  });

  const getMult = p => p.isDriver ? driverMult : 1.0;
  const owed = {};
  people.forEach(p => { owed[p.id] = 0; });

  if (gasAmt > 0) {
    const tm = people.reduce((s, p) => s + getMult(p), 0);
    if (tm > 0) people.forEach(p => { owed[p.id] += gasAmt * getMult(p) / tm; });
  }

  expenses.forEach(e => {
    const amt = parseFloat(e.amount) || 0;
    if (amt <= 0) return;
    const tgts = e.targets === 'all' ? people : people.filter(p => e.targetIds.includes(p.id));
    if (!tgts.length) return;
    const tm = tgts.reduce((s, p) => s + getMult(p), 0);
    if (tm > 0) tgts.forEach(p => { owed[p.id] += amt * getMult(p) / tm; });
  });

  const balances = people.map(p => ({
    ...p,
    paid: paid[p.id],
    owed: owed[p.id],
    balance: paid[p.id] - owed[p.id],
  }));

  const creds = balances.filter(b => b.balance > 0.5).map(b => ({ ...b })).sort((a, b) => b.balance - a.balance);
  const debts = balances.filter(b => b.balance < -0.5).map(b => ({ ...b })).sort((a, b) => a.balance - b.balance);
  const transfers = [];
  let ci = 0, di = 0;
  while (ci < creds.length && di < debts.length) {
    const amt = Math.min(creds[ci].balance, -debts[di].balance);
    if (amt > 0.5) {
      const r = roundTo(amt, rounding);
      if (r > 0) {
        transfers.push({
          from: debts[di].name || `参加者${di + 1}`,
          to: creds[ci].name || `参加者${ci + 1}`,
          amount: r,
        });
      }
    }
    creds[ci].balance -= amt;
    debts[di].balance += amt;
    if (creds[ci].balance < 0.5) ci++;
    if (debts[di].balance > -0.5) di++;
  }
  return { balances, transfers, gasAmt, totalCost };
}

export function encodeState(s) {
  try {
    return btoa(unescape(encodeURIComponent(JSON.stringify(s))));
  } catch {
    return '';
  }
}

export function decodeState(str) {
  try {
    return JSON.parse(decodeURIComponent(escape(atob(str))));
  } catch {
    return null;
  }
}
